import React, { Component } from "react";

export default class Searches extends Component {
  render() {
    return <>{this.props.children}</>;
  }
}
